import React, {Component} from 'react';
import { ToastContainer, toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.min.css';
import {connect} from "react-redux";

class ToastRx extends Component {

    componentWillReceiveProps(nextProps){
        let type_icon = '';
        if(nextProps.toast.type === 'success'){
            type_icon = '😃 ';
        }else if(nextProps.toast.type === 'sync'){
            type_icon = '🔁 ';
        }else if(nextProps.toast.type === 'error'){
            type_icon = '😢 ';
        } else if (nextProps.toast.type === 'table') {
            type_icon = '🍽 ';
        }else{
            type_icon = '😎 ';
        }
        toast.error(`${type_icon} ${nextProps.toast.message}`);
    }

    render() {
        return (
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnVisibilityChange
                draggable
                pauseOnHover
                progressClassName='toast'
                bodyClassName='toast-font'
            />
        );
    }
}

function mapStateToProps(state) {
    return {
        toast: state.get('toast'),
    };
}

export default connect(
    mapStateToProps
)(ToastRx);



// WEBPACK FOOTER //
// ./src/components/extras/ToastRx.js